import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  recursosSistema: []
};

const getters = {
  // Recursos Sistema
  recursosSistema: state => state.recursosSistema.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  recursosSistemaAtivo: state => state.recursosSistema.filter(r => r.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  async fetchRecursosSistema({ commit }, args) {
    const response = await axios.get(`${baseUrl}/recursossistema`);
    if (response.data.length) {
      const data = response.data.filter(recurso => recurso.Status.includes(args.status));
      commit('setRecursosSistema', data);
    } else {
      commit('setRecursosSistema', []);
    }
  },
  async fetchRecursoSistemaById({ commit }, id) {
    const response = await axios.get(`${baseUrl}/recursossistema/${id}`);

    if (response.data.length) {
      commit('setRecursosSistema', response.data);
      return response.data[0];
    } else {
      commit('setRecursosSistema', []);
    }
  },
}

const mutations = {
  // Recursos sistema
  setRecursosSistema: (state, recursosSistema) => state.recursosSistema = recursosSistema
}

export default {
  state,
  getters,
  actions,
  mutations
}